(() => {
  document.querySelectorAll('[data-zaoud-article-submit]').forEach((submitButton) => {
    const form = submitButton.closest('form');
    if (!form) return;

    form.addEventListener('submit', () => {
      const sendingLabel = submitButton.dataset.sendingLabel;
      const label = submitButton.querySelector('[data-submit-label]');

      if (label && sendingLabel) {
        label.textContent = sendingLabel;
      }

      submitButton.classList.add('is-loading');
      submitButton.disabled = true;
    });
  });

  if (window.location.hash === '#CommentSuccess') {
    const successMessage = document.getElementById('CommentSuccess');
    if (successMessage) {
      successMessage.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }
})();
